<template>
	<div class="rss-page page pt-5">
    <PageBlocked v-if="isBlocked" :blockRole="blockRole" />
    <div v-else-if="isBlocked !== null">
      <v-skeleton-loader type="card" v-if="loading" />
      <RssCard
          v-else-if="podcasts.length"
          v-for="(rss, index) in podcasts"
          :key="index"
          :item="rss"
          :isPodcast="isPodcast"
          :podcasts="podcasts"
          :index="index"
      />
      <NewsFeedEmpty
          v-else
          title="RSS/Podcasts is empty at the moment."
          description="Check back later."
      />
      <ScrollToTopButton />
    </div>

	</div>
</template>
<script>
import RssCard from '@/components/Rss/RssCard'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import ScrollToTopButton from '@/components/ScrollToTopButton'
import { mapActions, mapGetters } from 'vuex'
import PageBlocked from "@/components/PageBlocked.vue";
import Block from '@/mixins/Block.js'


export default {
	components: {
    PageBlocked,
		RssCard,
		NewsFeedEmpty,
		ScrollToTopButton,
	},
  mixins: [Block],
  data(){
    return{
      pageBlockedName: 'rss-feed',
    }
  },
	methods: {
		...mapActions('rss', ['getPodcasts']),
    ...mapActions('app', ['setPageTitle']),

		getRSSPodcasts() {
			this.getPodcasts(this.$route.query.feed_id)
		},
	},
	computed: {
		...mapGetters('rss', ['podcasts', 'loading']),

		isPodcast() {
			return !!(this.podcasts.length && this.podcasts[0].upload)
		},
	},
	watch: {
		'$route.query.feed_id': {
			handler(newValue) {
				this.getRSSPodcasts(newValue)
        this.setPageTitle(this.$route.query.title)
			},
		},
	},
	created() {
    if(this.isBlocked !== null){
      this.getRSSPodcasts()
    }
  },
  mounted() {
    this.setPageTitle(this.$route.query.title)
  },
  beforeDestroy() {
    this.setPageTitle('')
  }
}
</script>
<style lang="scss"></style>
